export const OK = 'Ok';
export const ERROR = 'Error';
